import { template } from "@ember/template-compiler";
import { service } from '@ember/service';
import { shouldShowBanner } from '../utils/datagrail';
// eslint-disable-next-line no-restricted-imports -- this interval is the budget for an external script to appear, so it must elapse
import { task, timeout } from 'ember-concurrency';
import Component from '@glimmer/component';
export default class DgConsentBanner extends Component {
    @service
    fastboot;
    constructor(){
        super(...arguments);
        this.pollForConsentBannerTask.perform();
    }
    @task(function*() {
        let shouldShow1 = shouldShowBanner(this.fastboot?.isFastBoot);
        if (!shouldShow1) {
            return;
        }
        const pollIntervalMs1 = 200;
        const maxPollMs1 = 10_000;
        const maxAttempts1 = Math.ceil(maxPollMs1 / pollIntervalMs1);
        for(let attempts1 = 0; attempts1 < maxAttempts1; attempts1++){
            if (typeof window.DG_BANNER_API?.showConsentBanner === 'function') {
                window.DG_BANNER_API.showConsentBanner();
                return;
            }
            yield timeout(pollIntervalMs1);
        }
    }).drop()
    pollForConsentBannerTask;
    static{
        template(`
    {{! intentionally renders nothing; polls for DG_BANNER_API and shows the consent banner }}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
